import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProductionToolProgramService extends Service {
	constructor(injector: Injector) {
		super("ProductionToolProgram", injector);
	}

	// API
	// Copies the program's machine and operator onto its operation, so the billet planner shows them.
	applyToOperation(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ApplyToOperation/${id}`, {});
	}

	completeTool(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CompleteTool/${id}`, {});
	}

	forOperation(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForOperation/${id}`);
	}

	forProductionTool(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProductionTool/${id}`);
	}

	forToolOrder(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForToolOrder/${id}`);
	}

	getWithRelations(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/WithRelations/${id}`);
	}

	secondSignOff(id: number, userProfileId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SecondSignOff/${id}`, { userProfileId });
	}

	setBlocks(id: number, toolOrderIds: number[]) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SetBlocks/${id}`, { toolOrderIds });
	}

	signOff(id: number, userProfileId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/SignOff/${id}`, { userProfileId });
	}
}
